import { Injectable } from '@angular/core'
import { select, Store, Action } from '@ngrx/store'

import * as EventTicketPackagesSelectors from './event-ticket-packages.selectors'
import { EventTicketPackagesState } from './event-ticket-packages.reducer'
import { SharedEventTicketPackagesFacade } from 'libs/shared/models/event-tickets/event-ticket-packages.models'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPackagesFacade implements SharedEventTicketPackagesFacade {
  loaded$ = this.store.select(EventTicketPackagesSelectors.selectEventTicketPackagesLoaded)
  allEventTicketPackages$ = this.store.select(EventTicketPackagesSelectors.selectAllEventTicketPackages)
  paidEventTicketPackages$ = this.store.select(EventTicketPackagesSelectors.selectPaidEventTicketPackages)
  count$ = this.store.select(EventTicketPackagesSelectors.selectCount)
  selectedEventTicketPackage$ = this.store.select(EventTicketPackagesSelectors.selectEntity)
  currentFilters$ = this.store.pipe(select(EventTicketPackagesSelectors.selectCurrentFilters))
  nextEventTicketPackageId$ = this.store.pipe(select(EventTicketPackagesSelectors.selectNextEventTicketPackageId))
  prevEventTicketPackageId$ = this.store.pipe(select(EventTicketPackagesSelectors.selectPrevEventTicketPackageId))
  displayColumns$ = this.store.select(EventTicketPackagesSelectors.selectDisplayColumns)
  dataView$ = this.store.pipe(select(EventTicketPackagesSelectors.selectDataView))
  editCreateLoaded$ = this.store.pipe(select(EventTicketPackagesSelectors.selectEditCreateLoaded))

  constructor(private store: Store<EventTicketPackagesState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
